module.exports = __webpack_public_path__ + "static/media/search_white.33c6edb5.svg";